var _path, _ellipse, _path2, _path3, _ellipse2, _path4, _ellipse3, _path5, _path6, _ellipse4, _path7, _ellipse5, _path8, _ellipse6, _path9, _path0, _ellipse7, _path1, _ellipse8, _path10, _path11, _ellipse9, _path12, _ellipse0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArticles = function SvgArticles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M1.722 2.789h10.174v6.909H1.722zM1.524 1.59h.783V.575c0-.125-.175-.226-.391-.226s-.392.101-.392.226z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.916,
    cy: 1.587,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.226,
    ry: 0.391,
    transform: "rotate(-90 1.916 1.587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    d: "M1.914 2.941c-.44 0-.836-.105-1.12-.273H.35v-.629c0-.498.7-.902 1.564-.902.863 0 1.563.402 1.565.9h.001v.631h-.445c-.284.168-.681.273-1.12.273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M1.914 2.941v.35zm-1.12-.273.178-.301a.35.35 0 0 0-.178-.049zm-.444 0H0c0 .193.156.35.35.35zm0-.629H0zm1.564-.902v-.35zm1.565.9-.35.001a.35.35 0 0 0 .35.348zm.001 0h.35a.35.35 0 0 0-.35-.35zm0 .631v.35a.35.35 0 0 0 .35-.35zm-.445 0v-.35a.35.35 0 0 0-.178.049zm-1.12.273v-.35c-.389 0-.722-.093-.943-.224l-.178.301-.178.301c.347.206.807.322 1.298.322zM.793 2.668v-.35H.35v.7h.444zm-.444 0H.7v-.629H0v.629zm0-.629H.7c0-.07.052-.202.283-.335.22-.127.55-.217.931-.217v-.7c-.482 0-.936.112-1.281.31C.297 1.293 0 1.613 0 2.04zm1.564-.902v.35c.381 0 .71.09.93.217.232.132.285.263.286.334l.35-.002.35-.002c-.003-.426-.3-.744-.636-.937-.345-.199-.798-.31-1.28-.31zm1.565.9v.35h.001v-.7zm.001 0h-.35v.631h.7v-.632zm0 .631v-.35h-.445v.7h.445zm-.445 0-.178-.301c-.221.13-.555.224-.943.224v.7c.49 0 .952-.116 1.3-.322z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.915,
    cy: 2.691,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.902,
    ry: 1.565,
    transform: "rotate(-90 1.915 2.691)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M.547 10.188h2.739V2.489c0-.436-.613-.79-1.37-.79-.756 0-1.37.354-1.37.79z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.916,
    cy: 10.183,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.79,
    ry: 1.37,
    transform: "rotate(-90 1.916 10.183)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    d: "M1.915 11.106c-.44 0-.836-.106-1.12-.274H.35v-.629c0-.498.7-.902 1.564-.902.863 0 1.563.402 1.565.9h.001v.631h-.445c-.284.168-.681.273-1.121.273"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M1.915 11.106v.35zm-1.12-.274.178-.301a.35.35 0 0 0-.178-.049zm-.444 0H0c0 .193.156.35.35.35zm0-.629H0zm1.564-.902v-.35zm1.565.9-.35.001a.35.35 0 0 0 .35.348zm.001 0h.35a.35.35 0 0 0-.35-.35zm0 .631v.35a.35.35 0 0 0 .35-.35zm-.445 0v-.35a.35.35 0 0 0-.178.049zm-1.121.273v-.35c-.388 0-.72-.093-.942-.224l-.178.301-.178.301c.347.206.807.322 1.298.323zm-1.12-.273v-.35H.35v.7h.444zm-.444 0H.7v-.629H0v.629zm0-.629H.7c0-.07.052-.202.283-.335.22-.127.55-.217.931-.217v-.7c-.482 0-.936.112-1.281.311-.336.194-.633.514-.633.941zm1.564-.902v.35c.381 0 .71.09.93.217.231.132.285.263.285.334l.35-.002.35-.002c-.002-.426-.3-.744-.635-.937-.345-.199-.799-.31-1.28-.31zm1.565.9v.35h.001v-.7zm.001 0h-.35v.631h.7V10.2zm0 .631v-.35h-.445v.7h.445zm-.445 0-.178-.301c-.221.13-.555.224-.943.224v.7c.49 0 .952-.116 1.3-.322z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.915,
    cy: 10.859,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.902,
    ry: 1.565,
    transform: "rotate(-90 1.915 10.86)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M1.524 12.129h.783v-1.015c0-.125-.175-.226-.391-.226s-.392.101-.392.226z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.916,
    cy: 12.126,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.226,
    ry: 0.391,
    transform: "rotate(-90 1.916 12.126)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M10.39 1.59h.783V.575c0-.125-.175-.226-.391-.226s-.391.101-.391.226z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.782,
    cy: 1.587,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.226,
    ry: 0.391,
    transform: "rotate(-90 10.782 1.587)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    d: "M10.78 2.941c-.44 0-.836-.105-1.12-.273h-.444v-.629c0-.498.7-.902 1.564-.902.863 0 1.563.402 1.566.9v.631h-.445c-.284.168-.681.273-1.12.273"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M10.78 2.941v.35zm-1.12-.273.178-.301a.35.35 0 0 0-.178-.049zm-.444 0h-.35c0 .193.157.35.35.35zm0-.629h-.35zm1.564-.902v-.35zm1.566.9-.35.001a.35.35 0 0 0 .35.348zm0 0h.35a.35.35 0 0 0-.35-.35zm0 .631v.35a.35.35 0 0 0 .35-.35zm-.445 0v-.35a.35.35 0 0 0-.178.049zm-1.12.273v-.35c-.389 0-.721-.093-.943-.224l-.178.301-.178.301c.347.206.808.322 1.298.322zm-1.12-.273v-.35h-.445v.7h.444zm-.445 0h.35v-.629h-.7v.629zm0-.629h.35c0-.07.053-.202.283-.335.22-.127.55-.217.931-.217v-.7c-.482 0-.936.112-1.28.31-.337.195-.634.515-.634.942zm1.564-.902v.35c.382 0 .71.09.931.217.23.132.284.263.285.334l.35-.002.35-.002c-.003-.426-.3-.744-.636-.937-.345-.199-.798-.31-1.28-.31zm1.566.9v.35zv-.35zm0 0h-.35v.631h.7v-.632zm0 .631v-.35h-.445v.7h.446zm-.445 0-.178-.301c-.221.13-.554.224-.943.224v.7c.491 0 .952-.116 1.3-.322z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.781,
    cy: 2.691,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.902,
    ry: 1.565,
    transform: "rotate(-90 10.781 2.691)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M9.413 10.184h2.74V2.485c0-.436-.614-.79-1.37-.79s-1.37.354-1.37.79z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.783,
    cy: 10.179,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.79,
    ry: 1.37,
    transform: "rotate(-90 10.783 10.18)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    d: "M10.781 11.106c-.44 0-.836-.106-1.12-.274h-.444v-.629c0-.498.7-.902 1.564-.902.863 0 1.563.402 1.566.9v.631h-.445c-.284.168-.681.273-1.12.273"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M10.781 11.106v.35zm-1.12-.274.178-.301a.35.35 0 0 0-.178-.049zm-.444 0h-.35c0 .193.156.35.35.35zm0-.629h-.35zm1.564-.902v-.35zm1.566.9-.35.001a.35.35 0 0 0 .35.348zm0 0h.35a.35.35 0 0 0-.35-.35zm0 .631v.35a.35.35 0 0 0 .35-.35zm-.445 0v-.35a.35.35 0 0 0-.178.049zm-1.12.273v-.35c-.389 0-.721-.093-.943-.224l-.178.301-.178.301c.347.206.807.322 1.298.323zm-1.12-.273v-.35h-.445v.7h.444zm-.445 0h.35v-.629h-.7v.629zm0-.629h.35c0-.07.053-.202.283-.335.22-.127.55-.217.931-.217v-.7c-.482 0-.936.112-1.281.311-.336.194-.633.514-.633.941zm1.564-.902v.35c.382 0 .71.09.931.217.23.132.284.263.285.334l.35-.002.35-.002c-.003-.426-.3-.744-.636-.937-.345-.199-.798-.31-1.28-.31zm1.566.9v.35zv-.35zm0 0h-.35v.631h.7V10.2zm0 .631v-.35h-.445v.7h.446zm-.445 0-.178-.301c-.221.13-.554.224-.943.224v.7c.491 0 .952-.116 1.3-.322z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.782,
    cy: 10.859,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.902,
    ry: 1.565,
    transform: "rotate(-90 10.782 10.86)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M10.39 12.129h.783v-1.015c0-.125-.175-.226-.391-.226s-.391.101-.391.226z"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.782,
    cy: 12.126,
    fill: "#F8F1E5",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    rx: 0.226,
    ry: 0.391,
    transform: "rotate(-90 10.782 12.126)"
  })));
};
export default SvgArticles;